const $win = $(window);
const $doc = $(document);

Shopify.colorProducts = Shopify.colorProducts || {};

let isTouch = false;
if (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  )
)
  isTouch = true;

if (isTouch) {
  $('body').addClass('is-touch');
}

$('.link-top').on('click', function(e) {
  e.preventDefault();

  $('html, body').animate(
    {
      scrollTop: 0,
    },
    1000
  );
});

$win.on('load scroll', function() {
  if ($win.scrollTop() > 300) {
    $('.link-top').addClass('visible');
  } else {
    $('.link-top').removeClass('visible');
  }
});

$win.on('resize orientationchange', function() {
  if ($win.width() < 768) {
    $('.js-qck-product').removeClass('expand-quickbuy-component');
  }
});

// 24.09.2019
$win.on('load', function() {
  checkSoldItems(false);

  $('.clickyboxes:not(.options--size) li a').on('click', function() {
    $this = $(this);
    checkSoldItems($this);
  });

  $('.options--size li a').on('click', function() {
    $('.options--size li a').removeClass('bolded-text');
    $this = $(this);
    $this.addClass('bolded-text');
  });
});

function checkSoldItems(selectedColor) {
  let arrDisabled = [];
  let arrAvailable = [];
  let currentSelectedColor;

  if (selectedColor) {
    currentSelectedColor = selectedColor.data('value');
  } else {
    currentSelectedColor = $('.clickyboxes:not(.options--size) li')
      .find('.active')
      .data('value');
  }

  $('.js-main-select option').each(function() {
    const $this = $(this);
    const colorVal = $this.data('color');
    const item = $this.data('size');

    if ($this.attr('disabled') === undefined && colorVal == currentSelectedColor) {
      arrAvailable.push(item);
    } else {
      arrDisabled.push(item);
    }
  });

  let uniqueAvailable = [...new Set(arrAvailable)];
  let uniqueDisabled = [...new Set(arrDisabled)];

  for (let i = 0; i < uniqueDisabled.length; i++) {
    let disabledItem = uniqueDisabled[i];

    for (let j = 0; j < uniqueAvailable.length; j++) {
      let availableItem = uniqueAvailable[j];

      if (availableItem == disabledItem) {
        uniqueDisabled[i] = 'remove-this-item';
      }
    }
  }

  let soldOutItems = uniqueDisabled.filter((el) => el != 'remove-this-item');

  $('.options--size li a').removeClass('out-of-stock');

  soldOutItems.forEach(function(element) {
    $('[data-value="' + element + '"]').addClass('out-of-stock');
  });
}

// 17.06.2020
//propagations start
$('body').on('click', function(e) {
  let target = $(e.target);
  if (target.hasClass('js-cart-drawer') || target.parents('.js-cart-drawer').length) {
    return;
  } else {
    $('body').removeClass('quick-add-popup-activate');
    $('.js-cart-drawer').removeClass('expanded');
  }
});
//propagations end

quantityInit();

$(document).on('click', '.js-qck-toggle', function(e) {
  e.preventDefault();
  const $this = $(this);
  const $productContainer = $this.parents('.js-qck-product');
  $productContainer.toggleClass('expand-quickbuy-component');

  sizesAvailable($productContainer);
});

$(document).on('click', '.js-qck-swatch', function(e) {
  e.preventDefault();
  const $this = $(this);
  const $productContainer = $this.parents('.js-qck-product');

  $this.siblings().removeClass('js-color-active');
  $this.addClass('js-color-active');

  sizesAvailable($productContainer);
});

$(document).on('click', '.js-qck-add a', function(e) {
  e.preventDefault();
  const $this = $(this);

  if (!$this.hasClass('is-unavailable')) {
    $this
      .parent()
      .addClass('current-size-selected')
      .siblings()
      .removeClass('current-size-selected');

    const $productContainer = $this.parents('.js-qck-product');
    const $selectMain = $productContainer.find('.js-qck-select');
    const currentSelectedColor = $productContainer.find('.js-color-active').data('swatch-value');
    const currentSelectedSize = $this.data('size-value');

    activateQuickAdd(currentSelectedColor, currentSelectedSize, $selectMain);
  }
});

$(document).on('click', '.js-cart-remove', function(e) {
  e.preventDefault();
  const url = $(this).attr('href');

  $.ajax({
    url: url,
    type: 'POST',
  })
    .done(() => {
      cartDrawerHtml(true);
    })
    .fail(() => {
      console.log('error cart remove');
    });
});

$(document).on('click', '.js-close-cart-drawer', function(e) {
  e.preventDefault();
  e.stopPropagation();
  const $this = $(this);

  $('body').removeClass('quick-add-popup-activate');

  $this.parents('.js-cart-drawer').removeClass('expanded');
});

$(document).on('click', '.js-remove-propagation', function(e) {
  e.stopPropagation();
});

$(document).on('click', '.js-btn-cart', function(e) {
  e.preventDefault();

  $('.js-cart-drawer').addClass('expanded');
  updateFreeShipping();
});

// quick add Functionality
function activateQuickAdd(currentColor, currentSize, $selectMain) {
  if (currentColor === undefined) {
    currentColor = $selectMain.find('option:selected').data('color');
  }

  $selectMain.find('option').each(function() {
    const $this = $(this);
    const itemColor = $this.data('color');
    const itemSize = $this.data('size');
    const isMatching = itemColor === currentColor && itemSize === currentSize;

    if (isMatching) {
      const $productContainer = $this.parents('.js-qck-product');
      const hasFinalClearance = $productContainer.find('.js-has-final-clearance');
      let properties = {};
    
      if(hasFinalClearance.length > 0){
        properties = { 'stock' : 'FINAL SALE - No returns accepted' }
      }

      const productId = { id: $this.val(), quantity: 1, properties };
      quickAddAjax(productId);
    }
  });
}

// check if sizes are available for quick add
function sizesAvailable($productContainer) {
  $productContainer.find('.is-unavailable').removeClass('is-unavailable');

  let arrDisabled = [];
  let arrAvailable = [];
  let currentSelectedColor = $productContainer.find('.js-color-active').data('swatch-value');
  let $selectMain = $productContainer.find('.js-qck-select');

  const distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  if (!currentSelectedColor) {
    currentSelectedColor = $selectMain.find('option:selected').data('color');
  }

  $selectMain.find('option').each(function() {
    const $this = $(this);
    const itemColor = $this.data('color');
    const itemSize = $this.data('size');

    if ($this.attr('disabled') === undefined && currentSelectedColor === itemColor) {
      arrAvailable.push(itemSize);
    } else {
      arrDisabled.push(itemSize);
    }
  });

  let uniqueAvailable = arrAvailable.filter(distinct);
  let uniqueDisabled = arrDisabled.filter(distinct);

  for (let i = 0; i < uniqueDisabled.length; i++) {
    let disabledItem = uniqueDisabled[i];

    for (let j = 0; j < uniqueAvailable.length; j++) {
      let availableItem = uniqueAvailable[j];

      if (availableItem == disabledItem) {
        uniqueDisabled[i] = 'remove-this-item';
      }
    }
  }

  let soldOutItems = uniqueDisabled.filter((el) => el != 'remove-this-item');

  soldOutItems.forEach(function(element) {
    const $soldOutSpan = $productContainer.find('[data-size-value="' + element + '"]');
    $soldOutSpan.addClass('is-unavailable');
  });
}

function quickAddAjax(productId) {
  $.post(
    '/cart/add.js',
    productId,
    () => {
      // reload cart
      cartDrawerHtml(false, true);
    },
    'json'
  ).error(() => {
    console.log('failed quick add new');
  });
}

function quantityInit() {
  quantityControls();
  quantityInput();
}

function quantityControls() {
  $(document).on('click', '.js-quantity .quantity-component__controls', function() {
    
    const $this = $(this);
    const $thisParent = $this.parent();
    const $qtyInput = $thisParent.find('.js-quantity-total');
    const maxQuantity = parseInt($qtyInput.attr('max'));
    const variantId = $qtyInput.data('vid');

    let qtyInputVal = $qtyInput.val();

    $thisParent.removeClass('has-error');

    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

    if ($this.hasClass('js-quantity-plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
    }

    if (qtyInputVal > maxQuantity && maxQuantity !== 0) {
      qtyInputVal = maxQuantity;
      $thisParent.addClass('has-error');
      return;
    }

    $qtyInput.val(qtyInputVal);

    cartChangeQuantity(variantId, qtyInputVal);
    
  });
}

function quantityInput() {
  $(document).on('change', '.js-quantity-total', function() {
    const $this = $(this);
    const $thisParent = $this.parent();
    const maxQuantity = parseInt($this.attr('max'));
    const variantId = $this.data('vid');
    let thisVal = $this.val();

    if (thisVal > maxQuantity && maxQuantity !== 0) {
      thisVal = maxQuantity;
    }

    $this.val(thisVal);

    cartChangeQuantity(variantId, thisVal);
  });
}

function cartChangeQuantity(variantId, qtyInputVal) {
  if (qtyInputVal < 0) {
    qtyInputVal = 0;
  }

  $.ajax({
    url: '/cart/change?id='.concat(variantId, '&amp;quantity=').concat(qtyInputVal),
    method: 'POST',
    dataType: 'json',
  })
    .done(() => {
      cartDrawerHtml(true);
    })
    .fail(() => {
      console.log('cart change quantity fail');
    });
}

function cartDrawerHtml(showOnReady = false, popupEffect = false) {
  $.get('/search', function(data) {
    var selectors = ['.page-header .header-cart', '.docked-navigation-container .header-cart'];
    var $parsed = $($.parseHTML('<div>' + data + '</div>'));
    for (var i = 0; i < selectors.length; i++) {
      var cartSummarySelector = selectors[i];
      var $newCartObj = $parsed.find(cartSummarySelector).clone();
      var $currCart = $(cartSummarySelector);
      $currCart.replaceWith($newCartObj);
    }
    theme.checkCurrency();

    if (showOnReady) {
      $('.js-cart-drawer').addClass('expanded');
    }

    if (popupEffect) {
      $('body').addClass('quick-add-popup-activate');
    }

    if ($('.js-cart-drawer').data('cart-items') === undefined) {
      $('body').removeClass('quick-add-popup-activate');
      $('.js-cart-drawer').removeClass('expanded');
    }

    updateFreeShipping();
  });
}

$doc.on('click', '.js-color-switch', function(e) {
  e.preventDefault();

  const $this = $(this);
  const $productHolder = $this.closest('.product-block');
  const productHandle = $this.data('handle');

  $this.closest('li').addClass('active').siblings().removeClass('active')

  if (Object.keys(Shopify.colorProducts).indexOf(productHandle) !== -1) {
    switchColorProduct(Shopify.colorProducts[productHandle], $productHolder)
  } else {
    getProductColors($productHolder, $this)
  }
})

function getProductColors($productHolder, $currentSwatch) {
  $.ajax({
    url: `/collections/${$currentSwatch.data('collection')}`,
    type: 'get',
    dataType: 'html'
  })
  .done((data) => {
    const $data = $(data);
    const $colorProducts = $data.find('.product-block');

    $colorProducts.each(function() {
      const $colorProduct = $(this);

      Shopify.colorProducts[$colorProduct.data('handle')] = $colorProduct.html();
    })

    switchColorProduct(Shopify.colorProducts[$currentSwatch.data('handle')], $productHolder)
  })
  .fail(() => {
    console.log("error");
  })
}

function switchColorProduct(colorProduct, $productHolder) {
  $productHolder.html(colorProduct)
  sizesAvailable($productHolder)
}


(function(history){
  var pushState = history.pushState;

  history.pushState = function(state) {
    if (typeof history.onpushstate == "function") {
      history.onpushstate({state: state});
    }
    
    return pushState.apply(history, arguments);
  }
})(window.history);

window.onpopstate = history.onpushstate = function(e) {
  var currentState = parseInt($('.header-cart__count').text())

  $.getJSON('/cart.js', function(data) {
    var actualState = parseInt(data.item_count);

    if (currentState != actualState) {
      $('.header-cart__count').text(actualState)
    }
  });
};


function giftProduct() {
  var isChecked = document.querySelector('#toggleGift');
  var gift = document.querySelector('#giftNote');
  var productId = 32580774985788;
  
  if(isChecked){
    isChecked.addEventListener('change', function() {
      if(isChecked.checked){
        gift.setAttribute('name', 'attributes[gift-message]');

        jQuery.post('/cart/add.js', {
            items: [
              {
                quantity: 1,
                id: productId,              
              }
            ]

          })
          .done(function() {
            console.log("success");
          });



      }else{
        gift.setAttribute('name', '');     
        jQuery.post('/cart/update.js', 'updates['+productId+']=0');
      }
    }, false);  
  }  
}

giftProduct();

function clearResults() { 	
  var divsToHide = document.getElementsByClassName("search-bar__results"); //divsToHide is an array	
  for(var i = 0; i < divsToHide.length; i++){	
      divsToHide[i].style.visibility = "hidden"; // or	
      divsToHide[i].style.display = "none"; // depending on what you're doing	
  }	
} 	
function clearInput() {	
  document.getElementById('{{ search_id }}').value = '';	
}

$(document).ready(function() {
  $('body').on('click', '.cart-summary-note .btn', function() {
    if ($(this).closest('.cart-notes-container').hasClass('open')) {
      $(this).closest('.cart-notes-container').removeClass('open');
      $(this).text('Add Order Note');
    } else {
      $(this).closest('.cart-notes-container').addClass('open');
      $(this).text('Save');
    }
  });
});

function updateFreeShipping() {
    var totalPriceVal = parseInt($('.cart-summary__subhead').data('value').split('$')[1]);
    var freeShippingVal = parseInt($('.cart-summary__subhead').data('shipping-price'));
    if (totalPriceVal >= freeShippingVal) {
      $('.cart-summary__subhead').html('<p>You are eligible for free shipping!</p>');
    } else {
      $('.cart-summary__subhead').html('<p>You’re $' + (freeShippingVal - totalPriceVal) + ' away from free standard shipping!</p>');
    }
  // }
}

$(document).ready(function() {
  // Enable pdp thumbnail click to slide 
  $('.product-thumbs div').on('click', function() {
    $('.slick-slider').slick('slickGoTo', $(this).index());
  });

  if (!window.location.href.includes('current-air-gift-card')) {
    // trigger cart button change                 
    var $atc = $('#shopify-section-product-template .product-form button[type="submit"]');
    
    $atc.on('touchstart click', function(){    
      if($(this).hasClass('btn-select-option')) {
        $(this).addClass('btn-cart-select');                           
        $(this).find('span').text('Select a size');    
      }    
    });
    
    $('#shopify-section-product-template .product-form .options--size li > a').on('click', function() {
      if ($(this).hasClass('out-of-stock')) {
        $atc.removeClass('btn-cart-select');
      } else {
        $atc.find('span').text('Add to Cart');
        $atc.removeClass('btn-cart-select');
        $atc.removeClass('btn-select-option');
      }
    });
  }

    byPassYotpoSMS();
});

function byPassYotpoSMS () {
  if ($win.width() < 769 && document.getElementById('referrals')) {
    var waitForYotpo = setInterval(() => {
      if ($('.yotpo-email-share-button').length > 0) {
        $('.yotpo-email-share-button').click();
        clearInterval(waitForYotpo);
      }
    }, 200);
  }
}

/* fix shoppay modal */
(function() {
  var callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            var modal = document.querySelector('shopify-installments-modal') || document.querySelector('shopify-installments-sample-plans-modal');
              if (modal && !modal.shadowRoot) {
                  // Create a new shadow root on the existing modal element
                  var shadowRoot = modal.attachShadow({mode: 'open'});

                  // Move all the modal's children into the shadow root
                  while (modal.firstChild) {
                      shadowRoot.appendChild(modal.firstChild);
                  }

                  console.log('Shopify modal children moved into shadow root');
              }
          }
      }
  };

  var observer = new MutationObserver(callback);

  observer.observe(document.body, { childList: true, subtree: true });
})();
